import type { Site } from '../Site';

export const PricePandaPH: Site = {
  id: 'pricepandaph',
  logo: '',
  label: 'PricePanda PH',
  analyticsName: 'pricepandaph',
  hostname: 'pricepanda.com.ph',
  platform: 'responsive',
  selector: 'main a',
};
